import React, { Component } from 'react';
import styles from './Shareholders.module.scss';

import ContentStore from 'stores/Content.store';

import { Container } from 'common/components/Layout/Layout';
import { injectIntl } from 'react-intl';

import get from 'lodash/get';
import KenticoTable from 'common/components/KenticoTable/KenticoTable';
import DonutChart from 'common/components/DonutChart/DonutChart';

import { isOnMobile } from 'utils/device-utils';
@injectIntl
class Shareholders extends Component {
  donutSettings = {
    width: !isOnMobile() ? '110%' : '90%',
    height: !isOnMobile() ? '110%' : '90%',
    borderSize: 0,
    arcSize: 18,
    labelFontSize: 5,
    showLabelImg: false
  };

  render() {
    let tableData = get(
      ContentStore,
      'content.homePageShareholders.tableData',
      null
    );
    let shareholders = get(
      ContentStore,
      'content.homePageShareholders.shareholderChartData',
      null
    );
    const { isForInvestors } = this.props;
    return (
      <Container
        className={
          !isForInvestors
            ? styles.Shareholders
            : styles.ShareholdersForInvestors
        }
      >
        {tableData ? (
          <KenticoTable
            data={tableData}
            style={!isForInvestors ? styles.Table : styles.TableForInvestors}
          />
        ) : null}
        {shareholders ? (
          <div className={styles.Chart}>
            <DonutChart {...this.donutSettings} dataSet={shareholders} />
            <div className={styles.Legend}>
              {shareholders.map((data, i) => (
                <div key={i} className={styles.ShareHolderLegendDiv}>
                  <div
                    className={styles.Square}
                    style={{ backgroundColor: data.color }}
                  />
                  <span>{data.label}</span>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </Container>
    );
  }
}

export default Shareholders;



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Management/Components/Shareholders/Shareholders.js